
import { useState } from 'react';

const faqs = [
  {
    question: 'Quais documentos preciso para alugar um veículo?',
    answer:
      'Você precisa de passaporte válido, carteira de motorista brasileira (CNH) válida e um cartão de crédito internacional em nome do condutor. A CNH brasileira é aceita na Flórida para turistas.',
  },
  {
    question: 'Onde é feita a retirada e devolução do veículo?',
    answer:
      'Realizamos a entrega e retirada do veículo diretamente no aeroporto de Orlando (MCO) ou no seu hotel/casa de temporada na região de Orlando. Pode haver custos adicionais.',
  },
  {
    question: 'O seguro está incluído no valor da diária?',
    answer:
      'Sim! Todos os nossos veículos incluem seguro completo (Full Coverage) no valor da diária. Você viaja com total tranquilidade, sem surpresas ou custos extras com proteção.',
  },
  {
    question: 'Posso adicionar um segundo motorista?',
    answer:
      'Sim, é possível adicionar motoristas adicionais. Basta informar no momento da reserva. O motorista adicional também precisa apresentar CNH válida e passaporte e possuir idade superior a 21 anos.',
  },
  {
    question: 'Qual é a política de combustível?',
    answer:
      'O veículo é entregue com o tanque cheio e deve ser devolvido também com o tanque cheio. Caso contrário, será cobrada uma taxa de reabastecimento. Para veículos híbridos, a economia de combustível é ainda maior!',
  },
  {
    question: 'Existe quilometragem limite?',
    answer:
      'Não! Todos os nossos planos incluem quilometragem ilimitada dentro do estado da Florida. Você pode viajar para Disney, Universal, Miami, Tampa e onde mais quiser sem se preocupar com limites. Viagens para fora do estado requerem prévia autorização.',
  },
  {
    question: 'Como funciona o suporte 24/7?',
    answer:
      'Nossa equipe está disponível 24 horas por dia, 7 dias por semana, via WhatsApp e telefone. Em caso de qualquer emergência ou dúvida durante sua viagem, estamos sempre prontos para ajudar em português.',
  },
  {
    question: 'Qual é a política de cancelamento?',
    answer:
      'Cancelamentos feitos com mais de 7 dias de antecedência recebem reembolso do valor deduzido de 20% como reservation fee. Alterações de data são gratuitas, mas sempre sujeitas à disponibilidade.',
  },
];

export default function FaqSection() {
  // Start with no panel open – using null makes the intent explicit
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(prev => (prev === index ? null : index));
  };

  return (
    <section id="faq" className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 bg-red-100 rounded-full">
            <span className="text-red-600 font-semibold text-sm">Dúvidas Frequentes</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">
            Perguntas Frequentes
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Tudo o que você precisa saber sobre nosso serviço de aluguel de vans em Orlando
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={index}
                className={`bg-white rounded-2xl shadow-md overflow-hidden transition-all duration-300 ${
                  isOpen ? 'shadow-lg ring-1 ring-blue-100' : 'hover:shadow-lg'
                }`}
              >
                <button
                  onClick={() => toggle(index)}
                  className="w-full flex items-center justify-between px-8 py-6 text-left cursor-pointer group"
                >
                  <span
                    className={`text-lg font-semibold pr-4 transition-colors ${
                      isOpen ? 'text-blue-900' : 'text-gray-900 group-hover:text-blue-900'
                    }`}
                  >
                    {faq.question}
                  </span>
                  <div
                    className={`w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${
                      isOpen
                        ? 'bg-red-600 rotate-180'
                        : 'bg-blue-100 group-hover:bg-blue-200'
                    }`}
                  >
                    <i
                      className={`ri-arrow-down-s-line text-xl transition-colors ${
                        isOpen ? 'text-white' : 'text-blue-900'
                      }`}
                    ></i>
                  </div>
                </button>

                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-8 pb-6">
                    <div className="h-px bg-gray-100 mb-5"></div>
                    <p className="text-gray-600 leading-relaxed text-base">{faq.answer}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-12 text-center bg-white rounded-2xl shadow-lg p-8">
          <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-full mx-auto mb-4">
            <i className="ri-question-answer-line text-3xl text-blue-900"></i>
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">Ainda tem dúvidas?</h3>
          <p className="text-gray-600 mb-6">
            Nossa equipe está pronta para ajudar você em português!
          </p>
          <a
            href="https://wa.me/13215949330?text=Ol%C3%A1!%20Tenho%20uma%20d%C3%BAvida%20sobre%20o%20aluguel%20de%20ve%C3%ADculos."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-green-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            Fale Conosco no WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
